import React, { useState } from 'react'
import PropTypes from 'prop-types'
import st from './ExportExcelButton.module.scss'
import { ReactComponent as ExportIcon } from 'components/UI/icons/paper_download.svg'

const ExportExcelButton = (props) => {
  const [isLoading, setIsLoading] = useState(false)

  const handleClick = async () => {
    if (isLoading) return
    setIsLoading(true)
    try {
      await props.downloadExcel(props.data)
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <button onClick={handleClick} className={st.button} disabled={isLoading}>
      <ExportIcon />
      <span>Выгрузить в Excel</span>
    </button>
  )
}

ExportExcelButton.propTypes = {
  data: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
  downloadExcel: PropTypes.func,
}

export default ExportExcelButton
